import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getUploadJobs = async (event_id: number, params?: any) => {
  const url = endpoints.UPLOAD_JOBS(event_id);
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });
  return response;
};

const getUploadJobStatus = async (job_id: string) => {
  const url = endpoints.UPLOAD_JOB_STATUS(job_id);
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const service = {
  getUploadJobs,
  getUploadJobStatus,
};

export default service;
